module.exports = __webpack_public_path__ + "img/line.cff71122.svg";